module.exports = __webpack_public_path__ + "media/warranty-claim/proof-doc-success-ba9a37a8.svg";